import { render } from "./shift-settings.vue?vue&type=template&id=78d81a6d&scoped=true"
import script from "./shift-settings.vue?vue&type=script&lang=js"
export * from "./shift-settings.vue?vue&type=script&lang=js"

import "./shift-settings.vue?vue&type=style&index=0&id=78d81a6d&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d81a6d"]])

export default __exports__